"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mapir_react_component_1 = __importDefault(require("mapir-react-component"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const useLocation_1 = require("../hooks/useLocation");
var marker = require('../../assets/marker.png');
var gps = require('../../assets/gps.png');
const API_KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjIxODhhZTExZTg0ZTBkNGY3MmE2ZTFlZjNhMWE2YWI5M2M1ODBhZjQ4M2MyMjMzNDc4NTA1YmE3NDE2MTZlOGViMzdhNWRmZjUyNjg0NjBjIn0.eyJhdWQiOiIxMTM2MyIsImp0aSI6IjIxODhhZTExZTg0ZTBkNGY3MmE2ZTFlZjNhMWE2YWI5M2M1ODBhZjQ4M2MyMjMzNDc4NTA1YmE3NDE2MTZlOGViMzdhNWRmZjUyNjg0NjBjIiwiaWF0IjoxNjA0MzQ2MDM1LCJuYmYiOjE2MDQzNDYwMzUsImV4cCI6MTYwNjg1MTYzNSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.Y3oo3P1P9GF1qsm6YlWuc-i_hRh1Y9y8UbBgRR5M5qVQ5HtwzzKgDjZ2svuEL98LLM_RZqTKeQ_O_8eABB3saq4dBggrL-BgcJ4bzXuFnBqTCOHgyXpNlOl3WN-JmagF6L2-zWB4etWu_RchnzXLiuI0FXMI0bH4z9UfN1jI2BjEeaKIEhuWXASaxrDPFcPGDGtSgaRtrr8fUiw6rs9zhjbuZGWJDU6pDyjISuEHjF7YoI_jS3i31ho7agJCTvb-fjAYVQEvrn2LPuTLOTNXK0-rhbzw8JG95EPPFomDqDH54dYonE1xs8yg_GxDX8mrzwdcG4ywUJ1-kF4SEuU97Q';
const MapApi = mapir_react_component_1.default.setToken({
    transformRequest: (url) => {
        return {
            url: url,
            headers: {
                'x-api-key': API_KEY,
                'Mapir-SDK': 'reactjs',
            },
        };
    },
});
const Map = ({ onRegionChange, region, style }) => {
    const { location, getPermission } = useLocation_1.useLocation();
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.map, style]) },
        react_1.default.createElement(mapir_react_component_1.default, { Map: MapApi, containerStyle: { flex: 1 }, center: region ? [region.longitude, region.latitude] : [51.6538, 32.637], onDragEnd: (map) => {
                const lat = map.transform._center.lat;
                const lng = map.transform._center.lng;
                onRegionChange &&
                    onRegionChange({
                        latitude: lat,
                        longitude: lng,
                        latitudeDelta: 0,
                        longitudeDelta: 0,
                    });
            } }),
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.gpsButton, onPress: async () => {
                if (location) {
                    await getPermission();
                    onRegionChange &&
                        onRegionChange({
                            latitude: location.coords.latitude,
                            longitude: location.coords.longitude,
                            latitudeDelta: 0,
                            longitudeDelta: 0,
                        });
                }
            } },
            react_1.default.createElement(react_native_1.Image, { source: gps, style: styles.gpsIcon })),
        react_1.default.createElement(react_native_1.Image, { source: marker, style: styles.marker })));
};
exports.default = Map;
const styles = react_native_1.StyleSheet.create({
    map: {
        borderRadius: styles_1.getRadius(),
        overflow: 'hidden',
    },
    gpsButton: {
        position: 'absolute',
        backgroundColor: 'rgba(255, 255, 2550, 0.7)',
        borderRadius: styles_1.getRadius(),
        padding: styles_1.getSpacing(0.5),
        top: 5,
        left: 5,
    },
    gpsIcon: {
        height: 30,
        width: 30,
    },
    marker: {
        position: 'absolute',
        bottom: '50%',
        right: 'calc(50% - 20px)',
        height: 40,
        width: 40,
    },
});
